/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LifeskillPagedResult } from '../../models/lifeskill-paged-result';

export interface GetLifeskill$Plain$Params {

/**
 * Format - int32.
 */
  page?: number;

/**
 * Format - int32.
 */
  pageSize?: number;
  'api-version'?: string;
}

export function getLifeskill$Plain(http: HttpClient, rootUrl: string, params?: GetLifeskill$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LifeskillPagedResult>> {
  const rb = new RequestBuilder(rootUrl, getLifeskill$Plain.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LifeskillPagedResult>;
    })
  );
}

getLifeskill$Plain.PATH = '/lifeskill';
